import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21ZM4 7V19H20V7H4ZM9.706 16.708L8.293 15.293L10.586 13L8.293 10.707L9.707 9.293L12 11.586L14.293 9.293L15.707 10.707L13.414 13L15.707 15.293L14.294 16.706L12 14.414L9.707 16.707L9.706 16.708Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "WindowClose"
);
